import type { CoreBundleResponse } from '@flecto/types'

import { api } from '../../../services/api'

export type GetAllBundlesOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  status?: 'enabled' | 'disabled' | 'drafting'
  on_store?: boolean
}

/**
 * Get all bundles.
 *
 * @endpoint GET /api/saas/me/bundles
 * @scope saas
 * @see https://flecto.dev/api-12969319
 */

export async function getAllBundles(
  options: GetAllBundlesOptions = {
    offset: 0,
    limit: 10000,
  }
): Promise<CoreBundleResponse> {
  const { data } = await api.get('/api/saas/me/bundles', { params: options })

  return data
}
